import { schema } from 'normalizr';
import type { PublicReportEntity, ReportEntity } from 'types/reports';

export const REPORT_SCHEMA_KEY = 'report';
export const PUBLIC_REPORT_SCHEMA_KEY = 'publicReport';
export const REPORT_DATA_USER_SCHEMA_KEY = 'user';
export const REPORT_DATA_LABEL_SCHEMA_KEY = 'label';
export const REPORT_DATA_DAYS_SCHEMA_KEY = 'day';
export const REPORT_DATA_CLIENT_SCHEMA_KEY = 'client';
export const REPORT_DATA_CLIENT_PROJECT_SCHEMA_KEY = 'project';
export const REPORT_DATA_TEAM_SCHEMA_KEY = 'team';
export const REPORT_DATA_LINKED_WORK_SCHEMA_KEY = 'linked_work';

// Reports
export const reportSchema = new schema.Entity<ReportEntity>(REPORT_SCHEMA_KEY);
export const reportListSchema = [reportSchema];

// Public Reports
export const publicReportSchema = new schema.Entity<PublicReportEntity>(PUBLIC_REPORT_SCHEMA_KEY);
export const publicReportListSchema = [publicReportSchema];

// ReportData:User
export const reportDataUserSchema = new schema.Entity(REPORT_DATA_USER_SCHEMA_KEY);
export const reportDataUserListSchema = [reportDataUserSchema];

// ReportData:Label
export const reportDataLabelSchema = new schema.Entity(REPORT_DATA_LABEL_SCHEMA_KEY);
reportDataLabelSchema.define({ children: [reportDataLabelSchema] });
export const reportDataLabelListSchema = [reportDataLabelSchema];

// ReportData:Days
export const reportDataDaysSchema = new schema.Entity(
  REPORT_DATA_DAYS_SCHEMA_KEY,
  {},
  {
    idAttribute: value => value.day,
  }
);
export const reportDataDaysListSchema = [reportDataDaysSchema];

// ReportData:ClientProject
export const reportDataClientProjectSchema = new schema.Entity(
  REPORT_DATA_CLIENT_PROJECT_SCHEMA_KEY
);

// ReportData:Client
export const reportDataClientSchema = new schema.Entity(REPORT_DATA_CLIENT_SCHEMA_KEY, {
  projects: [reportDataClientProjectSchema],
});
export const reportDataClientListSchema = [reportDataClientSchema];

export const reportDataTeamSchema = new schema.Entity(REPORT_DATA_TEAM_SCHEMA_KEY);
export const reportDataTeamListSchema = [reportDataTeamSchema];

export const reportDataLinkedWorkSchema = new schema.Entity(
  REPORT_DATA_LINKED_WORK_SCHEMA_KEY,
  {},
  {
    idAttribute: value => value.id,
  }
);
export const reportDataLinkedWorkListSchema = [reportDataLinkedWorkSchema];

export const reportDataSchema = new schema.Object({
  clients: reportDataClientListSchema,
  users: reportDataUserListSchema,
  labels: reportDataLabelListSchema,
  days: reportDataDaysListSchema,
  teams: reportDataTeamListSchema,
  linked_work: reportDataLinkedWorkListSchema,
});
